// Addresses describe the imported tree, never the rendered product index.
export function canvasNodes(pkg) {
  const result = {};
  const visit = (node, path) => {
    result[path] = node;
    (node.children || []).forEach((child, i) => visit(child, `${path}/children/${i}`));
    ['template', 'empty'].forEach((key) => { if (node[key]) visit(node[key], `${path}/${key}`); });
  };
  Object.entries(pkg.pages).forEach(([page, content]) => content.sections.forEach((section) => visit(section.root, `${page}/${section.id}/root`)));
  return result;
}

export function sectionSettings(section) {
  const keys = new Set();
  const visit = (value) => {
    if (!value || typeof value !== 'object') return;
    if (value.setting) keys.add(value.setting);
    Object.values(value).forEach(visit);
  };
  visit(section.root);
  return [...keys];
}

export function collectionRows(node, override, definition, edits, catalogue) {
  const kind = override.kind || definition.kind;
  const ids = override.ids === null ? undefined : override.ids ?? (kind === definition.kind ? edits.collections[node.collection] : undefined);
  return (catalogue[kind] || []).filter((p) => ids === undefined || ids.includes(p.id)).slice(0, override.limit || 200);
}

export const PRODUCT_KINDS = {meal_item:'Meal items', meal_plan:'Meal plans', meal_pass:'Meal passes', catering:'Catering'};
